import { render, staticRenderFns } from "./ActesTypeArticles.vue?vue&type=template&id=4c83ea7f&"
import script from "./ActesTypeArticles.vue?vue&type=script&lang=js&"
export * from "./ActesTypeArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports